<template>
    <div class="doc-section">
        <h1>Visualización de Geocercas</h1>
        <p>
            Las geocercas son perímetros virtuales vinculados a un dispositivo que permiten monitorear entradas, salidas
            o permanencia en zonas específicas.
        </p>
        <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <h2>¿Cómo visualizar las geocercas?</h2>
        <div v-if="plataforma === 'web'" class="platform-content">
            <p>
                Para proyectar las áreas delimitadas en el mapa, realice los siguientes pasos dentro de la tabla de
                dispositivos:
            </p>
            <ul class="ul-contenedor step-list">
                <li>Ubique el dispositivo deseado en el listado lateral derecho.</li>
                <li>Haga clic en el icono de <strong>Geocercas</strong></li>
                <li>El sistema renderizará automáticamente sobre el mapa todas las figuras geométricas vinculadas
                    exclusivamente a esa unidad.</li>
            </ul>

            <div class="card">
                <p>
                    <strong>Nota de visualización:</strong> Una vez activadas, las geocercas aparecerán con su color y
                    transparencia predefinidos, permitiendo identificar rápidamente si el dispositivo se encuentra
                    dentro o
                    fuera del perímetro.
                </p>
            </div>

            <h3>Referencia visual</h3>
            <CarruselAciqui :items="imagenesGeocercas" />
        </div>

        <div v-if="plataforma === 'moviles'" class="platform-content">
            <p>
                Para proyectar las áreas delimitadas en el mapa, realice los siguientes pasos dentro de la tabla de
                dispositivos:
            </p>
            <ul class="ul-contenedor step-list">
                <li>Ubique el dispositivo deseado en el listado lateral derecho.</li>
                <li>Haga clic en el icono de <strong>Geocercas</strong></li>
                <li>El sistema renderizará automáticamente sobre el mapa todas las figuras geométricas vinculadas
                    exclusivamente a esa unidad.</li>
            </ul>

            <div class="card">
                <p>
                    <strong>Nota de visualización:</strong> Una vez activadas, las geocercas aparecerán con su color y
                    transparencia predefinidos, permitiendo identificar rápidamente si el dispositivo se encuentra
                    dentro o
                    fuera del perímetro.
                </p>
            </div>

            <h3>Referencia visual</h3>
            <CarruselAciqui :items="imagenesGeocercasMoviles" />
        </div>

    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'GeocercasDetalle',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesGeocercas: [
            {
                nombre: "Visualización de Geocercas",
                url: "img/monitoreo/VerGeocerca.png",
                descripcion: "Mapa mostrando las geocercas asociados al GPS seleccionado."
            }
        ],
        imagenesGeocercasMoviles: [
            {
                nombre: "Visualización de Geocercas",
                url: "img/monitoreo/moviles/VerGeocerca.png",
                descripcion: "Mapa mostrando las geocercas asociados al GPS seleccionado."
            }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>